module.exports = {"PAGES":[]}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/customPages.json
// module id = 1801
// module chunks = 1